import { ValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/validation-message-resolver';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class MaxValidationMessageResolver implements ValidationMessageResolver<{ max: unknown }> {
  private readonly translateService = inject(TranslateService);

  readonly errorCode = Validators.max.name;

  getMessage(error?: { max: unknown }): string {
    return this.translateService.instant('label.validation.max', { value: error?.max });
  }
}
